import React, { useState, useContext, createRef, useEffect } from 'react';
import { Header, Dropdown, Menu, Checkbox, Card, Container, Segment, Sticky, Grid, Input, GridRow, Divider, GridColumn, ButtonContent } from 'semantic-ui-react';
import { Button, Form, Icon, Image, List, Label, Transition, Modal } from 'semantic-ui-react';
import { Link, useParams, useLocation, Redirect } from 'react-router-dom';
import { AppState } from '../../context';
import { Loader, Dimmer } from 'semantic-ui-react';
import { dbTasks, dbCaregivers, dbFamMember, dbFamtoFam, dbPending } from '../../firebase';
import LoginF from './LoginF';
import firebase from 'firebase/app';
import SecondaryProfile from './SecondaryProfile'

const SecondaryFamHomepage = () => {

  const sendText = firebase.functions().httpsCallable('sendText');
   const { userid } = useParams();
  const someContext = useContext(AppState);
  //const [logged, setLogged] = useState(false);
  const {
    familyMembers,
    logged,
    filter,
    setFilter,
    pending,
    filtercaregiver,
    setFilterCaregiver,
    filter2nd,
    setFilter2nd,
    filtermine,
    filterAll,
    setFilterAll,
    setFilterMine,
    filterunassigned,
    setFilterunassigned,
  } = someContext;
  
  const [existingTasks, setExistings] = useState([]);
  const [caregivers, setContextCare]=useState("");
  const[firstName, setFirstName]=useState("");
  const[lastName, setLastName]=useState("");
  const[type,setType]=useState("");
  const[famID,setFamID]=useState("") // primary family member id
  const[activeItem,setActiveItem]=useState('home') 
  const[totalcaregivers,setCaregivers]=useState([]); // all the caregivers
  const[otherFamMembers,setOtherFamMembers]=useState([]); //ALL fam members beside the secondary one.
  const[othersTaskList, setTaskOthers]=useState([]); // all tasks ids for all other fam members in FAMTOFAM
  const[caregiversTasks,setCaregiversTasks]=useState([]); // all task ids for what's in all caregivers tasks ... 
  const[famtoCaregiver,setFamtoCaregiver]=useState([]) // not done yet
  const[tasks,setTasks]=useState([]);
  const[famtofam, setFamtofam]=useState("")
  const [notes, setNotes]=useState("");
  const [BoolAll, setBoolAll]=useState(false)
  const [today,setToday]=useState("Today")



  useEffect(() => {
    const handleData = snap => {
      if (snap.val()) setFamtofam(snap.val());
    }
    dbFamtoFam.on('value', handleData, error => alert(error));
    return () => { dbFamtoFam.off('value', handleData); };
  }, []);

  useEffect(() => {
    const handleData = snap => {
      if (snap.val()) setContextCare(snap.val());
    }
    dbCaregivers.on('value', handleData, error => alert(error));
    return () => { dbCaregivers.off('value', handleData); };
  }, []);

  useEffect(() => {
    const handleData = snap => {
      if (snap.val()) setTasks(snap.val());
    }
    dbTasks.on('value', handleData, error => alert(error));
    return () => { dbTasks.off('value', handleData); };
  }, []);
  
  useEffect(()=>{
    const  initialzeName = (snappy3) =>{
      setFamID(snappy3.val().familyMembers);
      setFirstName(snappy3.val().firstName);
      setLastName(snappy3.val().firstName);
      setType(snappy3.val().type);
      if(snappy3.val().tasksfromfam){
        setExistings(Object.values(snappy3.val().tasksfromfam))
      }
      
     
    }
    dbFamMember.child(userid).on('value',initialzeName,error=>alert(error));
    return ()=>{dbFamMember.child(userid).off('value',initialzeName)}
  }, []);

  useEffect(()=>{
    const  initialzeName = (snappy3) =>{
    if(snappy3.val()[famID]){
      setCaregivers(snappy3.val()[famID]["caregivers"]);
      var temp=snappy3.val()[famID]['secondaryFam'];
      var tempactual=temp.filter((input)=> input!==userid)
      tempactual.push(famID) // otherFam includes the primary family member.
      setOtherFamMembers(tempactual);
      createCaregiverTaskIDList(snappy3.val()[famID]["caregivers"]);
      setNotes(snappy3.val()[famID]["notes"]);
    }
  }
    dbFamMember.on('value',initialzeName,error=>alert(error));
    return ()=>{dbFamMember.off('value',initialzeName)}
  }, [famID]);

  useEffect(()=>{
    const  initialzeName = (snappy3) =>{
      initializeFamtoFam();


    }
  
    dbFamMember.on('value',initialzeName,error=>alert(error));
    return ()=>{dbFamMember.off('value',initialzeName)}
  }, [otherFamMembers]);


  function initializeFamtoFam(){
    var tempMaster=[];
    for(let i=0; i<otherFamMembers.length;i++)
    {

      var array=getAllTasks(otherFamMembers[i]);

      tempMaster=tempMaster.concat(array);
    }
    setTaskOthers(tempMaster);
  }
  function getAllTasks(indexIntoFamtoFam){
    var returnable=[];
   if(familyMembers[indexIntoFamtoFam]["tasksfromfam"]){
   
     for(let i=0; i< Object.values(familyMembers[indexIntoFamtoFam]["tasksfromfam"]).length; i++){
       
      returnable.push(Object.values(familyMembers[indexIntoFamtoFam]["tasksfromfam"])[i])
     }
     return returnable;
   }
   else{
     return [];
   }
  }
// }
 
  //create taskidList:
  function createCaregiverTaskIDList(input){
    var temp=[];
    if(input){
    for(let i=0; i<input.length;i++) // for every caregiver
    {
      if(caregivers[input[i]] && caregivers[input[i]]["tasks"]){
        var myTasks= Object.values(caregivers[input[i]]["tasks"]);
        for(let j=0;j<myTasks.length;j++){ //for every task
          temp.push(tasks[myTasks[j]]); 
          
        }
      }
    }
    setCaregiversTasks(temp);
  }

  }
  

  const PageHeader = () => {
    return (
      <Segment
      basic
      style={{ backgroundColor: "#006990", textAlign: "center", marginBottom: "0px" }}
      fluid="true"
    >     
      <Menu pointing compact>
          <Menu.Item
            name='home'
            icon='tasks'
            active={activeItem === 'home'}
            onClick={()=>setActiveItem('home')}
          />   
          <Menu.Item
            name='Notes'
            active={activeItem === 'notes'}
            onClick={()=>setActiveItem('notes')}
          /> 
          <Menu.Item
            icon="clipboard outline"
            name='Summary'
            active={activeItem === 'tasks'}
            onClick={()=>setActiveItem('tasks')}
          />
          <Menu.Item
            icon='user'
            style={{
              color: 'white',backgroundColor: "#006990"
          }
          }
            active={false}
            onClick={()=>setActiveItem('profile')}
          />
      </Menu>
     
      </Segment>
    );
  };
  const TopMenuF = ({ user }) => {
    const location = useLocation();
    return (
      <Menu
        pointing
        fixed="top"
        widths={3}
        style={{ backgroundColor: "white" }}

      >
        <Menu.Item
          active={location.pathname === "/viewfamily" | location.pathname === "/viewfamily/edit/:taskid" | location.pathname === "/viewfamily/:userid"}
          as={Link}
          to={`/viewfamily/${user}`}
        >
          <Header
            as="h4"
            icon='tasks'
            color="black"
            content="TaskList"
          />
        </Menu.Item>
        <Menu.Item active={user ? location.pathname === `/viewfamily/summary/${user}` : ""} as={Link} to={user ? `/viewfamily/summary/${user}` : "/viewfamily"}>
          <Header
            as="h4"
            color="black"
            content={"Summary"}
            icon='clipboard outline'
          />
        </Menu.Item>
        <Menu.Item active={user ? location.pathname === `/viewfamily/profile/${user}` : ""} as={Link} to={user ? `/viewfamily/profile/${user}` : "/viewfamily"}>
          <Header
            as="h4"
            color="black"
            content={"Profile"}
            icon='user'
          />
        </Menu.Item>
      </Menu>
    )
  }
  function Update_click(status) {
    if (famtofam) {
      let new_status = !famtofam[status.input]["status"];
      dbFamtoFam.child(status.input).update({
        "status": new_status, 
        "statusLastChecked": {'.sv': 'timestamp'}
        
      })

    }
  }
  function testToday(id){
    if(famtofam[id]['duebydate']){
    var date= new Date(famtofam[id]['duebydate']);
    var arry=date.toString().split(" ");
    console.log("this is the date")
    console.log(arry);
    console.log(todayString.toString().split(" "));
    console.log(date)
    console.log(todayString)
    if(arry[0]==todayString.split(" ")[0] && arry[1]==todayString.split(" ")[1] && arry[2]==todayString.split(" ")[2] && arry[3]==todayString.split(" ")[3]){
      console.log('correctomondo')
      console.log(date)
      console.log(todayString)
      return true;
    }
    var createdonDate=new Date(famtofam[id]['createdOn'])
    console.log(createdonDate)
    console.log(arry)
    
    var todaystime= new Number(todayDate)
    var timedue=  new Number(famtofam[id]['duebydate'])
    if(date.getDay() == todayDate.getDay() && famtofam[id]['frequency']=="Weekly" && todaystime>=timedue ){
      console.log('correctomondo2')
      console.log(date)
      console.log(todayString)
      return true;
    }
    else if((famtofam[id]['frequency']==="Everyday" || famtofam[id]['frequency']==="Twice a Day" )&& todaystime>=timedue){
      console.log('correctomondo3')
      console.log(date)
      console.log(todayString)
      return true;
    }

    else{
      return false;
    }
  }
  else{
    return true;
  }
  }

  function helper11(input) {


    if (famtofam && familyMembers && input && famtofam[input] && !famtofam[input]["status"] ) 
    // && testToday(input)
    {

      var temp;
   
      var date= new Date(famtofam[input]["createdOn"]);
      temp =((date).getMonth()+1).toString() +"/"+ (date).getDate().toString() +" at "+ (date).getHours().toString() + ":";
      if(date.getMinutes() < 10 ){
        temp=temp+"0"+date.getMinutes().toString();
      } else{
        temp=temp+date.getMinutes().toString();
      }
      return (
     
      <Grid.Row>
       
          <List.Item>
            
            <List.Content>
            <List.Icon>
              <Checkbox checked={famtofam[input]["status"]} onClick={() => Update_click({ input })} />
            </List.Icon> 
            
            <List.Header style={{marginLeft:"10px", "font-size": "large"}}as="a">{famtofam[input]["taskName"] + ":"}</List.Header>
            <List.Description as="a">{" "+famtofam[input]["description"]} <strong>{" of " +famtofam[input]["importance"]} Importance </strong></List.Description>
                <List.Description as="a">   Assigned on  {temp} by {familyMembers[famtofam[input]['AssignedbyFam']]['firstName']} </List.Description>
                {/* for
                                            {" " + tasks[input]["duration"]} */}
                </List.Content>
          </List.Item>
         </Grid.Row>                                   
      )
    }
    else {
      return null;
    }
  }
  function helper22(input) {

    if (famtofam && familyMembers && input && famtofam[input] && famtofam[input]["status"] )
    // && testToday(input)
    {
      var temp;
   
      var date= new Date(famtofam[input]["statusLastChecked"]);
      temp =((date).getMonth()+1).toString() +"/"+ (date).getDate().toString() +" at "+ (date).getHours().toString() + ":";
      if(date.getMinutes() < 10 ){
        temp=temp+"0"+date.getMinutes().toString();
      } else{
        temp=temp+date.getMinutes().toString();
      }
      return (
        <Grid.Row>
       
          <List.Item>
            
            <List.Content>
            <List.Icon>
              <Checkbox checked={famtofam[input]["status"]} onClick={() => Update_click({ input })} />
            </List.Icon> 
            
            <List.Header style={{marginLeft:"10px", "font-size": "large"}}as="a">{famtofam[input]["taskName"]}</List.Header>
      <List.Description as="a">   Completed on  {temp} </List.Description>
               
                
              </List.Content>
          </List.Item>
         </Grid.Row>             
      )
    }
    else {
      return null;
    }
  }
  
  const TodoList=({active})=>{
    
    if(active && existingTasks.length>0)
    {
     return(
     <Container>
         <Transition.Group
           as={List}
           duration={1000}
           divided
           relaxed
           verticalAlign='middle'
         >
           <Grid padded>
           <Header style={{marginTop: '10px', marginBottom:'10px'}}as='h2' textAlign="center">Your Tasks Today</Header>
           {familyMembers ? existingTasks.map((input) => helper11(input)) : ""}
           {familyMembers ? existingTasks.map((input) => helper22(input)) : ""}
           <Container>
             <Container>
             <Button padded floated="center" fluid content="Add a task" circular icon='add' as={Link} to={`/viewfamily/createtask/${userid}`} />
             
             </Container>
          </Container>
           </Grid>
           {/* <Button fluid positive onClick={()=>setIsModalOpen(true)}>Add Task for {famFirstName}</Button> */}
         </Transition.Group>
       </Container>);
  }
    else if(active){
    return(
    <Container>
          <Header textAlign="center" style={{marginTop:"10px"}}> No tasks assigned to you as yet!</Header>

      <Container>
             <Container>
             <Button padded floated="center" fluid content="Add a task" circular icon='add' as={Link} to={`/viewfamily/createtask/${userid}`} />
             
             </Container>
          </Container>
    </Container>
    
    );
  }
       else{
         return null
       }
   };
   const [todayDate, setDate]=useState(new Date())
   const [todayString, setTodayString]=useState(todayDate.toString())
   function sendSMSFamilyMember(taskID) {
    var number2 = "";
    dbFamtoFam.child(taskID).once('value').then(function (temp) {
      var taskname = temp.val().taskName
      var description = temp.val().description;
      var time = temp.val().time;
      var importance = temp.val().importance;
      var freq = temp.val().frequency;


      var c = "Task: " + taskname + " at approximately " + time + "Description: " + description + "Importance: "
        + importance + "Frequency: " + freq;

      dbFamtoFam.child(temp.val().AssignedtoFam).child("phone").once("value", function (snapshot) {
        number2 = snapshot.val()

      }, function (errorObject) {
        console.log("The read failed: " + errorObject.code);
      });
      let tempe = { to: number2, body: c };

      sendText({ data: tempe });
    });

  }


  function sendSMSCaregiver(taskID) {

    var number2 = "";
    dbTasks.child(taskID).once('value').then(function (temp) {
      var taskname = temp.val().taskName
      var duration = temp.val().duration
      var description = temp.val().description;
      var time = temp.val().time;
      var importance = temp.val().importance;
      var freq = temp.val().frequency;


      var c = "Task: " + taskname + " at approximately " + time + "Description: " + description + "Importance: "
        + importance + "Frequency: " + freq;

      dbCaregivers.child(temp.val().caregiverId).child("phone").once("value", function (snapshot) {
        number2 = snapshot.val()

      }, function (errorObject) {
        console.log("The read failed: " + errorObject.code);
      });
      let tempe = { to: number2, body: c };
      sendText({ data: tempe });
    });
  }

  function testToday(id){
    if(id['duebydate']){

    
    var date= new Date(id['duebydate']);
    var arry=date.toString().split(" ");
    console.log("this is the date")
    console.log(arry);
    console.log(todayString.toString().split(" "));
    if(arry[0]==todayString.split(" ")[0] && arry[1]==todayString.split(" ")[1] && arry[2]==todayString.split(" ")[2] && arry[3]==todayString.split(" ")[3]){
      console.log('correctomondo')
      return true;
    }
    var todaystime= new Number(todayDate)
    var timedue=  new Number(id['duebydate'])
    var createdonDate=new Date(id['createdOn'])
    console.log(createdonDate)
    if(date.getDay() == todayDate.getDay() && id['frequency']=="Weekly" && todaystime>=timedue){
      return true;
    }
    else if(id['frequency']==="Everyday" || id['frequency']==="Twice a Day" && todaystime>=timedue){
      return true;
    }
    else{
      return false;
    }
  }
  else{
    return true;
  }
  }

   function EachItem1Caregiver({ id }) {
  
      var  temp;
    var date= new Date(id["createdOn"]);

   

    temp =((date).getMonth()+1).toString() +"/"+ (date).getDate().toString() +" at "+ (date).getHours().toString() + ":";
    if(date.getMinutes() < 10 ){
      temp=temp+"0"+date.getMinutes().toString();
    } else{
      temp=temp+date.getMinutes().toString();
    }

     if(!id["status"] && (BoolAll|| testToday(id))){

  
   
    return (
      <Grid.Row>
        <Grid.Column>
          <Segment raised>
            <Label as='a' ribbon>
              Incomplete - {caregivers ? caregivers[id["caregiverId"]]["firstName"]:
              ""}
        </Label>
            <span><strong>{id["taskName"]}</strong></span>
            <List.Item> <strong>Due by:</strong> {id["time"]}</List.Item>
            {/* <List.Item> <strong>Duration:</strong> {id["duration"]}</List.Item> */}
            
            <List.Item> <strong>Assigned On</strong> {temp} by {familyMembers ? familyMembers[id["familyMemberID"]]["firstName"]:
            ""} </List.Item>
            <Button
              // attached='bottom'
              fluid='false'
              icon="share"
              content={`Send reminder to ${caregivers ? caregivers[id["caregiverId"]]["firstName"]:
              ""}`}
              style={{ marginTop: "10px" }}

              onClick={() => sendSMSCaregiver(id)}
            />
          </Segment>
        </Grid.Column>
      </Grid.Row>);
         }
         else{
           return null;
         }
    
  }

  function EachItem2Caregiver({ id }) {
    if(id["status"]&& (testToday(id)||BoolAll)){
    var  temp;
    var date= new Date(id["statusLastChecked"]);
    temp =((date).getMonth()+1).toString() +"/"+ (date).getDate().toString() +" at "+ (date).getHours().toString() + ":";
    if(date.getMinutes() < 10 ){
      temp=temp+"0"+date.getMinutes().toString();
    } else{
      temp=temp+date.getMinutes().toString();
    }


    return (
      <Grid.Row>
        <Grid.Column>
          <Segment raised>
            <Label as='a' color='green'   ribbon>
              Completed by  {caregivers ? caregivers[id["caregiverId"]]["firstName"]:
              ""}
        </Label>
            <span><strong>{id["taskName"]}</strong></span>
            <List.Item> <strong>Due at:</strong> {id["time"]}</List.Item>
            {/* <List.Item> <strong>Description:</strong> {id["description"]}</List.Item> */}
            <List.Item> <strong>Completed on:</strong> {temp}</List.Item>
          </Segment>
        </Grid.Column>
      </Grid.Row>);
          }
          else{
            return null;
          }
  }
  function EachItemF1({ id }) {

    function testtoday(){
      if(famtofam[id]['duebydate']){

      
      var date= new Date(famtofam[id]['duebydate']);
      var arry=date.toString().split(" ");
      console.log("this is the date")
      console.log(arry);
      console.log(todayString.toString().split(" "));
      if(arry[0]==todayString.split(" ")[0] && arry[1]==todayString.split(" ")[1] && arry[2]==todayString.split(" ")[2] && arry[3]==todayString.split(" ")[3]){
        console.log('correctomondo')
        return true;
      }
      var createdonDate=new Date(famtofam[id]['createdOn'])
      console.log(createdonDate)
      
      var todaystime= new Number(todayDate)
      var timedue=  new Number(famtofam[id]['duebydate'])
      if(date.getDay() == todayDate.getDay() && famtofam[id]['frequency']=="Weekly" && todaystime>=timedue ){
        return true;
      }
      else if((famtofam[id]['frequency']==="Everyday" || famtofam[id]['frequency']==="Twice a Day" )&& todaystime>=timedue){
        return true;
      }

      else if(BoolAll && (filtermine || filter2nd)){
        return true;
      }
        else{
        return false;
      }
    }
    else{
      return true;
    }
  }
  console.log(filterAll)
    
    
    if (famtofam[id]["status"] && (testtoday() || BoolAll)){
      var  temp;
    var date= new Date(famtofam[id]["statusLastChecked"]);
    temp =((date).getMonth()+1).toString() +"/"+ (date).getDate().toString() +" at "+ (date).getHours().toString() + ":";
    if(date.getMinutes() < 10 ){
      temp=temp+"0"+date.getMinutes().toString();
    } else{
      temp=temp+date.getMinutes().toString();
    }
    return (
      <Grid.Row>
        <Grid.Column>
          <Segment raised>
            <Label as='a' color='green' ribbon>
              Completed by {familyMembers ? familyMembers[famtofam[id]["AssignedtoFam"]]["firstName"]:
                ""}
        </Label>
            <span><strong>{famtofam ? famtofam[id]["taskName"] : ""}</strong></span>
            <List.Item> <strong>Due at:</strong> {famtofam ? famtofam[id]["time"] : ""}</List.Item>
            <List.Item> <strong>Completed On:</strong> {famtofam ? temp : ""}</List.Item>

             </Segment>
        </Grid.Column>
      </Grid.Row>);
  }
  else if(!famtofam[id]["status"] && (testtoday() || BoolAll)){
    var  temp;
    var date= new Date(famtofam[id]["createdOn"]);
    temp =((date).getMonth()+1).toString() +"/"+ (date).getDate().toString() +" at "+ (date).getHours().toString() + ":";
    if(date.getMinutes() < 10 ){
      temp=temp+"0"+date.getMinutes().toString();
    } else{
      temp=temp+date.getMinutes().toString();
    }
    return (
      <Grid.Row>
        <Grid.Column>
          <Segment raised>
            <Label as='a' ribbon>
              Incomplete - {familyMembers ? familyMembers[famtofam[id]["AssignedtoFam"]]["firstName"]:
                ""}
        </Label>
            <span><strong>{famtofam ? famtofam[id]["taskName"] : ""}</strong></span>
            <List.Item> <strong>Due at:</strong> {famtofam ? famtofam[id]["time"] : ""}</List.Item>
            <List.Item> <strong>Assigned On:</strong> {famtofam ? temp : ""}</List.Item>
            <Button
                // attached='bottom'
                fluid="true"
                icon="share"
                content={`Send reminder to ${familyMembers ? familyMembers[famtofam[id]["AssignedtoFam"]]["firstName"]:
                ""}`}
                style={{ marginTop: "10px" }}

                onClick={() => sendSMSFamilyMember(id)}
              />
          </Segment>
        </Grid.Column>
      </Grid.Row>);
  }
  else{
    return <div></div>;
  }
  }

  function EachItemU1({ id }) {
    const [confirmmodal, setConfirmModal] = useState(false)
    function FirebaseRewrite() {
      if (familyMembers && pending[id] && pending[id]["AssignedbyFam"])
      {
        temp = pending[id];
        temp["AssignedtoFam"] = userid;
        console.log(pending[id]["AssignedbyFam"])
        console.log( pending[id]["AssignedtoFam"]);
        if(familyMembers[pending[id]["AssignedbyFam"]] && familyMembers[pending[id]["AssignedtoFam"]])
        {
          console.log(id)
          if (Object.keys(pending).length > 1) 
          {    
            dbPending.child(id).remove();
            if (Object.values(familyMembers[famID]["unassignedTasks"]).length == 1){
              console.log("if: ", familyMembers[userid])
              dbFamMember.child(famID).child("unassignedTasks").child(id).remove()
              dbFamMember.child(famID).update({
                "unassignedTasks": "null",
              })
            }
            else{
              console.log(familyMembers[famID])
              dbFamMember.child(famID).child("unassignedTasks").child(id).remove()
            }
          }
          const dataToPush = {
            [id]: temp
          }
          dbFamtoFam.update(dataToPush);
          if(familyMembers[pending[id]["AssignedtoFam"]]["tasksfromfam"]){
            dbFamMember.child(pending[id]["AssignedtoFam"]).child("tasksfromfam").update({
              [id]: id || null
            }); 
          }
          else{
            dbFamMember.child(pending[id]["AssignedtoFam"]).child("tasksfromfam").update({
              [id]: id || null
            }); 
            console.log(familyMembers[pending[id]["AssignedbyFam"]]);
            
          }

          console.log(familyMembers[pending[id]["AssignedbyFam"]]["taskstofam"])
          if(familyMembers[pending[id]["AssignedbyFam"]]["taskstofam"]){
            console.log("if")
            dbFamMember.child(pending[id]["AssignedbyFam"]).child("taskstofam").update({
              [id]: id || null
            })
          }
          else{
            console.log("else")
            dbFamMember.child(pending[id]["AssignedbyFam"]).child("taskstofam").update({
              [id]: id || null
            })
          }
        }
      }
      else{
        console.log("Doesnt work")
      }
      setConfirmModal(false);
    }
    if (pending[id]["status"]) {
      var temp;
      var date = new Date(pending[id]["createdOn"]);
      temp = ((date).getMonth() + 1).toString() + "/" + (date).getDate().toString() + " at " + (date).getHours().toString() + ":";
      if (date.getMinutes() < 10) {
        temp = temp + "0" + date.getMinutes().toString();
      } else {
        temp = temp + date.getMinutes().toString();
      }

      return (
        <Grid.Row>
          <Grid.Column>
            <Segment raised>
              <Label as='a' color='green' ribbon>Completed </Label>
              <strong>{pending ? pending[id]["taskName"] : ""}</strong>
              <List.Item> <strong>Description:</strong> {pending ? pending[id]["description"] : ""}</List.Item>
              <List.Item> <strong>Completed on:</strong> {temp}</List.Item>
            </Segment>
          </Grid.Column>
        </Grid.Row>);
    }
    else if (!pending[id]["status"]) {
      var temp;
      var date = new Date(pending[id]["createdOn"]);

      temp = ((date).getMonth() + 1).toString() + "/" + (date).getDate().toString() + " at " + (date).getHours().toString() + ":";
      if (date.getMinutes() < 10) {
        temp = temp + "0" + date.getMinutes().toString();
      } else {
        temp = temp + date.getMinutes().toString();
      } return (

        <Grid.Row>
          <Modal open={confirmmodal} size='small' closeOnEscape={true} basic >
            <Header icon='archive' />
            <Modal.Content>
              Do you want to add <strong>{pending ? pending[id]["taskName"] : ""}</strong> to your tasklist?
            </Modal.Content>
            <Modal.Actions>
              <Button basic color='red' inverted onClick={() => setConfirmModal(false)}>
                <Icon name='remove' /> No</Button>
              <Button color='green' inverted onClick={() => FirebaseRewrite()}>
                <Icon name='checkmark' /> Yes</Button>
            </Modal.Actions>
          </Modal>
          <Grid.Column>
            <Segment raised >
              <Label as='a' ribbon color='yellow'>
                Unassigned</Label>
              <span><strong>{pending ? pending[id]["taskName"] : ""}</strong></span>
              <List.Item> <strong>Description:</strong> {pending ? pending[id]["description"] : ""}</List.Item>
              <List.Item> <strong>Assigned  on:</strong> {temp} by {familyMembers ? familyMembers[pending[id]["AssignedbyFam"]]["firstName"]:
                ""}</List.Item>
                 <Button
                content="Add to my tasks"
                icon="plus"
                fluid='true'
                onClick={() => setConfirmModal(true)}
                style={{ marginTop: "10px" }}
              />
            </Segment>
          </Grid.Column>
        </Grid.Row>);
    }
    else {
      return null;
    }
  }
  const Options = [
    // { key: 'Todays Tasks', value: 'Todays Tasks', text: 'Todays Tasks' },
    { key: 'All Tasks', value: 'All Tasks', text: 'All Tasks' },
    { key: 'My Tasks', value: 'My Tasks', text: 'My Tasks' },
    { key: 'Caregiver Tasks', value: 'Caregiver Tasks', text: 'Caregiver Tasks' },
    { key: 'Family Tasks', value: 'Family Tasks', text: 'Family Tasks' },
    { key: 'Unassigned Tasks', value: 'Unassigned Tasks', text: 'Unassigned Tasks' },
  ]

  const todayOptions = [
    {key: 1, value: "Today", text: "Today"},
    {key: 2, value: "All", text:"All"}
  ]

const OtherTodoList=({active}) =>{
  function Filtering(value) {
    setFilter(value)
    if (value == "All Tasks") {
      setFilter2nd(true);
      setFilterCaregiver(true);
      setFilterMine(true);
      setFilterunassigned(true);
      // setFilterAll(true);
    }
    // if (value == "Todays Tasks") {
    //   setFilter2nd(true);
    //   setFilterCaregiver(true);
    //   setFilterMine(true);
    //   setFilterunassigned(true);
    //   setFilterAll(false)
    // }
    else if (value == "My Tasks") {
      setFilter2nd(false);
      setFilterCaregiver(false);
      setFilterMine(true);
      setFilterunassigned(false);
      // setFilterAll(false);

    }
    else if (value == "Caregiver Tasks") {
      setFilter2nd(false);
      setFilterCaregiver(true);
      setFilterMine(false);
      setFilterunassigned(false);
      // setFilterAll(false)

    }
    else if (value == "Family Tasks") {
      setFilter2nd(true);
      setFilterCaregiver(false);
      setFilterMine(true);
      setFilterunassigned(false);
      // setFilterAll(false);

    }
    else if (value == "Unassigned Tasks") {
      setFilter2nd(false);
      setFilterCaregiver(false);
      setFilterMine(false);
      setFilterunassigned(true);
      // setFilterAll(false)
    }
  }
  function todayChange(value){
      
    if(value=="Today"){
      setBoolAll(false)
      setToday("Today")
    }
    else{
      setBoolAll(true)
      setToday("All")
    }
  }








  
    // // 
    // const[othersTaskList, setTaskOthers]=useState([]); // all tasks ids for all other fam members in FAMTOFAM
    // const[caregiversTasks,setCaregiversTasks]=useState([]); // all task ids for what's in all caregivers tasks ... 

    if(active)
    return(
      <Container>
        <Grid padded>
              <Grid.Row>
                <Grid.Column width={8}>
        <div style={{ marginTop: "5px", marginLeft: "0px", marginBottom: "10px", textAlign: "start" }}>
              <Menu compact>
                <Dropdown text={filter}
                  options={Options}
                  simple item
                  onChange={(e, { value }) => Filtering(value)} />
              </Menu>
        </div>
        </Grid.Column>
        <Grid.Column width={4}>
        <div style={{ marginTop: "5px", marginLeft: "0px", marginBottom: "0px", textAlign: "start" }}>
                    <Menu compact>
                      <Dropdown text={today}
                        options={todayOptions}
                        simple item
                        onChange={(e, { value }) => todayChange(value)} />
                    </Menu>
                  </div>
                  </Grid.Column>
                  <Grid.Column width={4}>
                  <div>

                  </div>
                  </Grid.Column>
            </Grid.Row>

        </Grid>
        <Transition.Group
        as={List}
        duration={1000}
        divided
        relaxed
        verticalAlign='middle'
      >

        {/* <Header style={{marginTop: '10px', marginBottom:'10px'}}as='h4' textAlign="center">Other Family Member Tasks</Header> */}
        
        {filter2nd ? <Grid padded>
        {othersTaskList.map((input) => <EachItemF1 id={input} />)}
        </Grid> : ""}
        {filtermine  ? 
        <Grid padded>
        {existingTasks.map((input)=><EachItemF1 id={input} />)}

        </Grid> : " "}
        
        
  
       
        {/* {familyMembers ? othersTaskList.map((input) => helper2(input)) : ""} */}
        {/* <Header style={{marginTop: '10px', marginBottom:'10px'}}as='h4' textAlign="center">Caregiver Tasks</Header> */}
        {filtercaregiver ? <Grid padded>
        {familyMembers ? caregiversTasks.map((input) => <EachItem1Caregiver id= {input} />) : ""}
        {familyMembers ? caregiversTasks.map((input) => <EachItem2Caregiver id= {input} />) : ""}
        
        </Grid>  : ""}

        {/* <Header style={{marginTop: '10px', marginBottom:'10px'}}as='h4' textAlign="center">Unassigned Tasks</Header> */}
        {filterunassigned ? <Grid padded>
        {familyMembers[famID]["unassignedTasks"] !== "null" && pending ? Object.values(familyMembers[famID]["unassignedTasks"]).map((input) => <EachItemU1 id={input}/>) : ""}
        </Grid> : ""}
      </Transition.Group>
    </Container>);
      else{
        return null
      }
   };
   const Notes=({active})=>{
    function helper2(note){
      return(
          <Grid.Row>
          <Grid.Column>
            <Segment raised>
            <Label as='a' ribbon>
            {note["category"]}
      </Label>
          <span><strong>{note["title"]}</strong></span>
          <List.Item> <strong>{note["description"]}</strong></List.Item>
          {/* <List.Item> <strong>Created On: </strong> {tasks ? temp : ""}</List.Item> */}

            </Segment>
      </Grid.Column>
    </Grid.Row>
      );
  }
  function helper(caregiverid){
      if (caregivers && caregivers[caregiverid]){
          return (Object.values(caregivers[caregiverid]["notes"]).map((note)=>helper2(note)));
      }
      else{
        return null;
      }
  }
  if(active && familyMembers[famID]['careBool']){
  return (
    tasks && famtofam && caregivers && familyMembers?
      <div>
        <Container>
          {/* <div style={{ marginTop: "15px", marginLeft: "0px", marginBottom: "10px", textAlign: "start" }}>
            { <Menu compact>
              <Dropdown text={filter}
                options={Options}
                simple item
                onChange={(e, { value }) => Filtering(value)} />
            </Menu> }
          </div> */}
          <Grid padded>
           {Object.values(familyMembers[famID]["caregivers"]).map((id)=>helper(id))}
           
          </Grid>
        </Container>
      </div> :
      <Dimmer active>
        <Loader size='huge'>Loading</Loader>
      </Dimmer>
  )
        }
        else if(active){
          return(
        <Header textAlign="center" style={{marginTop:"10px"}}> No Caregiver set up yet! Add one by going to settings and clicking 'Add Caregiver' and they will be able to add daily updates and medical updates for you here.</Header>
          )
        }
        else{
          return null
        }
    
   }

  return (
    logged ?
      <div>
        <PageHeader />
        <TodoList active={activeItem=='home'}/>
        <OtherTodoList active={activeItem=='tasks'} />
        <Notes active={activeItem=='notes'} /> 
        <SecondaryProfile active={activeItem=='profile'} />
      </div>
      : <Redirect to={'/familymembers'} push={true} />
  );
}

export default SecondaryFamHomepage;